/**
 * Jeevak chat widget
 * Maintains a short conversation history and POSTs to <endpoint>/chat.
 * Renders bot replies and, when a product handle comes back, a small link.
 * Preview mode (no endpoint) returns a canned reply so the UI is testable.
 */
(function () {
  const root = document.querySelector(".jv-jeevak");
  if (!root) return;

  const endpoint = (root.dataset.endpoint || "").trim().replace(/\/$/, "");
  const shopUrl = (root.dataset.shopUrl || "").replace(/\/$/, "");
  const fab = root.querySelector("[data-jv-open]");
  const panel = root.querySelector("[data-jv-panel]");
  const closeBtn = root.querySelector("[data-jv-close]");
  const log = root.querySelector("[data-jv-log]");
  const form = root.querySelector("[data-jv-form]");
  const input = root.querySelector("[data-jv-input]");

  const history = []; // {role, content}

  function openPanel() { panel.hidden = false; fab.setAttribute("aria-expanded", "true"); input.focus(); }
  function closePanel() { panel.hidden = true; fab.setAttribute("aria-expanded", "false"); }
  fab.addEventListener("click", () => (panel.hidden ? openPanel() : closePanel()));
  closeBtn.addEventListener("click", closePanel);
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closePanel(); });

  function addMsg(text, who, handle) {
    const el = document.createElement("div");
    el.className = "jv-jeevak__msg jv-jeevak__msg--" + who;
    el.textContent = text;
    if (handle) {
      const a = document.createElement("a");
      a.className = "jv-jeevak__product";
      a.href = shopUrl + "/products/" + handle;
      a.textContent = "View " + handle.replace(/-/g, " ") + " →";
      el.appendChild(a);
    }
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function typing() {
    const el = document.createElement("div");
    el.className = "jv-jeevak__msg jv-jeevak__msg--bot jv-jeevak__typing";
    el.innerHTML = "<span></span><span></span><span></span>";
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const text = input.value.trim();
    if (!text) return;
    addMsg(text, "user");
    history.push({ role: "user", content: text });
    input.value = "";
    const t = typing();

    try {
      let data;
      if (!endpoint) {
        await new Promise((r) => setTimeout(r, 700));
        data = { text: "Thanks for sharing. (Preview mode — connect the Jeevak backend to get real answers.) A light, early dinner and warm water after meals is a good first step.", product_handle: null };
      } else {
        const res = await fetch(endpoint + "/chat", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ messages: history }),
        });
        if (!res.ok) throw new Error("chat " + res.status);
        data = await res.json();
      }
      t.remove();
      addMsg(data.text || "…", "bot", data.product_handle);
      history.push({ role: "assistant", content: data.text || "" });
      // cap history to keep costs bounded
      if (history.length > 12) history.splice(0, history.length - 12);
    } catch (err) {
      console.error("Jeevak chat error", err);
      t.remove();
      addMsg("Jeevak is resting for a moment — please try again shortly.", "bot");
    }
  });
})();
